<template>
    <div id="Application" class="app-inner">
          <div class="public-btn-div flex align-cen"  v-if="!selectType && !authType">
      <div class="public-add"  @click="addApp">
        新增应用 
      </div>
    </div>
     <div class="p-tit-c">
        <div class="businessList-filter">
             <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">应用名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入应用名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">应用ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入应用ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
      <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">应用分类：</div>
          <el-cascader
                :options="itemList"
                v-model="value"
                @change="classSelect"
                separator="--"
                clearable
                change-on-select
                 ref="cascaderRef"
                >
            </el-cascader>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">应用类型：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(0)"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="searchList" >客户端型应用</el-radio>
        <el-radio v-model="radio" label="2" @change="searchList">网页型应用</el-radio>
        <el-radio v-model="radio" label="3" @change="searchList">展示型应用</el-radio>
        <el-radio v-model="radio" label="4" @change="searchList">3D网页型应用</el-radio>
      </div>
          <div class="businessList-filter-list flex align-cen"
          v-if="!authType"
          >
        <div class="label">应用状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(1)"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="1" @change="searchList">启用中</el-radio>
        <el-radio v-model="radio1" label="0" @change="searchList">禁用</el-radio>
      </div>
         <div class="businessList-filter-list flex align-cen">
        <div class="label">规格信息：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
           @click="allradio(2)"
        >
          不限
        </div>
        <el-radio v-model="radio2" label="1" @change="searchList">免费产品</el-radio>
        <el-radio v-model="radio2" label="sku1" @change="searchList">付费-时长制</el-radio>
        <el-radio v-model="radio2" label="sku2" @change="searchList">付费-面议</el-radio>
      </div>
         <div class="businessList-filter-list flex align-cen">
        <div class="label">应用官网分类：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
           @click="allradio(3)"
        >
          不限
        </div>
        <el-radio v-model="radio3" label="1" @change="searchList">和隆优化官网</el-radio>
        <el-radio v-model="radio3" label="2" @change="searchList">和隆软件官网</el-radio>
      </div>
        <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
        </div>
     </div>
     <div class="businessList-container">
         <div class="businessList-container-table">
              <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
         <el-table-column type="selection" width="55" reserve-selection v-if="selectType"> 
         </el-table-column>
          <el-table-column label="排序" align="center" prop="sort" width="70">
         </el-table-column>
         <el-table-column label="应用图片" align="center" prop="pic">
            <template slot-scope="scope" >
                <img :src="scope.row.pic ? scope.row.pic : ''" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0">
                <img src="../../assets/images/nullimg.png" alt="" v-else style="display: block;width:50%;margin:0 auto">
            </template>
         </el-table-column>
         <el-table-column label="应用ID" align="center" prop="id" width="160">
         </el-table-column>
         <el-table-column label="应用官网分类" align="center" width="200">
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
          <el-table-column label="规格信息" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.payType == '1'">免费</span>
              <span v-if="scope.row.payType == 2 && scope.row.payModel == 2">面议付费</span>
              <el-button type="text" size="small" style="color:red" v-if="scope.row.payType == 2 && scope.row.payModel == 1" @click="seeSku(scope.row)">查看规格</el-button>
            </template>
          </el-table-column>
          <el-table-column label="应用名称" align="center" prop="appName" width="200">
         </el-table-column>
          <el-table-column label="应用类型" align="center" prop="type" >
            <template slot-scope="scope">
                <span v-if="scope.row.id !=0">{{scope.row.type == 1 ? '客户端应用': scope.row.type == 2 ? '网页型应用' : scope.row.type == 3 ? '展示型应用' : scope.row.type == 4 ? '3D网页型应用' : ''}}</span>
                <span v-else style="color:red">系统预设应用</span>
            </template>
         </el-table-column>
          <el-table-column label="应用分类" align="center" prop="classifyName" width="200">
         </el-table-column>
          <el-table-column label="最新版本号" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.id !=0">{{scope.row.versionNum}}</div>
              <div v-else>1.0</div>
            </template>
         </el-table-column>
           <el-table-column label="应用状态" align="center"
            v-if="!selectType && !authType"
           >
            <template slot-scope="scope">
              <div class="buStatus" @click="changeStatus(scope)" v-if="scope.row.id !=0">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
              <div v-else>
                <el-switch
                  v-model="scope.row.state == 0 ? true : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="250"
            v-if="!selectType && !authType"
            >
                 <template slot-scope="scope">
                <div v-if="scope.row.id !=0">
                   <el-button type="text" size="small" @click="preview(scope.row)">预览</el-button>
                  <el-button type="text" size="small" @click="openPoster(scope.row)">查看链接海报</el-button>
                   <el-button type="text" size="small" @click="openVersion(scope.row)">版本</el-button>
                    <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
                </div>
                <div v-else>
                 <el-button type="text" size="small" style="color:red">禁止操作</el-button> 
                </div>
            </template>
            </el-table-column>
               <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="100"
            v-if="authType == 1"
            >
            <template slot-scope="scope">
               <el-button type="text" size="small" style="color:red" @click="emitchose(scope.row)">选择</el-button>
            </template>
               </el-table-column>
              </el-table>
               <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
         </div>
     </div>
         <el-dialog
  title="查看链接海报"
  :visible.sync="centerDialogVisible1"
  width="440px"
  :append-to-body="true"
  center>
     <div class="dia-can">
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">保存</div>
  <div class="linkdiv">
     应用链接：{{link}}
    <span @click.stop="copy(link)" style="color:#409eff;cursor: pointer;">复制</span>
  </div>
</el-dialog>
     <el-dialog
  title="所有规格"
  :visible.sync="centerDialogVisible2"
  width="60%"
  :append-to-body="true"
  center>

      <div class="businessList-container-table">
              <el-table
          ref="multipleTable1"
          :data="skuArr"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
            <el-table-column prop="id" label="规格编号" align="center" width="200">
          </el-table-column>

          <el-table-column prop="name" label="规格名称" align="center" width="200">
          </el-table-column>
          <el-table-column  label="销售价格" align="center">
             <template slot-scope="scope">
             ￥{{scope.row.salePrice}}
            </template>
          </el-table-column>
           <el-table-column label="原价" align="center">
            <template slot-scope="scope">
             ￥{{scope.row.originalPrice}}
            </template>
          </el-table-column>
            <el-table-column  label="支撑账号个数" align="center" width="200">
              <template slot-scope="scope">
                {{scope.row.accountNum || '无限制'}}
              </template>
          </el-table-column>
           <el-table-column  label="使用期限（月）" align="center">
            <template slot-scope="scope">
                {{scope.row.deadline || '无'}}
              </template>
          </el-table-column>
           </el-table>
      </div>
       </el-dialog>
    </div>
</template>
<script>
import {getApplicationTypeList} from "@/api/index/index"  //应用分类
import {getApplicationList} from "@/api/index/index" //应用列表
import {editApplication,skuList} from "@/api/index/index" //修改应用、规格列表
export default {
    name:'Application',
    props: {
    selectType: [String, Boolean], //是否为组件调用 
    authType:[String, Number],
    bussID:[String, Number],
    importName:[String, Number],
    isAppId:[Boolean]
    },
    data: () =>{
        return {
        zznum:0,
        dowloadImgName:'应用海报',
        skuArr:[],
        centerDialogVisible1:false,
        centerDialogVisible2:false,
        search:'',
        search1:'',
        itemList:[
        ],
        value:[],
        radio:'',
        radio1:'',
        radio2:'',
        radio3:'',
        list:[],
        multipleSelection:[],
        catchStatus:false,
           totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        selsctarr:[],
        link:'',
        posterImg:'',
          painting: {
                    width: '371px',
                    height: '460px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: '',
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                         {
                            type:'image',
                            url: require('../../assets/images/HeroopSys.png'),
                            css: {
                                top:'150px',
                                 width: "130px",
                                 height:"44px",
                                 textAlign: "center",
                                 left:"120.5px"
                            }
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'210px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '250px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：北京和隆软件有限公司',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
                },
        }
    },
        activated(){
  this.gethisInfo()
},
    created(){
      if(this.authType) this.gethisInfo()
        this.$nextTick(() =>{
            this.getthisType()
        })
        
    },
    methods: {
      // 查看规格
       seeSku(data){
        this.skuArr = []
          skuList({
                id:data.id,
                    })
                .then(res => {
                  this.skuArr = res.data
                })
                .catch(err => {
                })
        this.centerDialogVisible2 = true
      },
      // 打开版本
      openVersion(data){
           this.$router.push({
            name: "Appedition",
            query:{
                id:data.id,
                appName:data.appName,
                appType:data.type
            }
           })
      },
      // 复制链接
          copy(link){
             let _self = this
      this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
    },
    // 海报绘制成功钩子
            success(src) {
             this.posterImg = src;
            },
              // 海报绘制失败钩子
            fail(err) {
                console.log('fail', err)
            },
         // 手动修改海报views
        handleChangeImg(data){
            this.painting.views[0].url = data.pic
            
             this.painting.views[2].text = data.appName
             this.painting.views[3].content = this.$config.prUrl + '#/webenterprise/endowloadDetail?id='+ data.id + '&type=2'
        },
  // 打开海报
          openPoster(data){
            if(data.state == 1){
              this.centerDialogVisible1 = true
              this.handleChangeImg(data)
              this.dowloadImgName = data.appName + '应用海报'
              this.link = this.$config.prUrl + '#/webenterprise/endowloadDetail?id='+ data.id + '&type=2'
            }else{
              this.$message.error('请先开启状态')
            }
          },
                // 打开预览页面
    preview(data){
        const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: data.id,type:1}})
        window.open(newurl.href,'_blank')
    },
      // 打开编辑应用页面
      openEdit(data){
             this.$router.push({
            name: "editApplication",
            query:{
                id:data.id,
            }
           })
      },
         // 表格选择
         handleSelectionChange(val) {
            if(this.catchStatus){
            this.multipleSelection = val;
             let arr =  this.multipleSelection
               console.log(val)
           if(this.selsctarr && this.selsctarr.length){
            //  isAppId ? 
              let add = this.selsctarr.filter(item=>!arr.some(ele=>ele.id===item.id)) 
                console.log(add)
            for (const key in add) {
             this.multipleSelection.push({
                    'pic': add[key].pic,
                    'id':add[key].id,
                    'appName':add[key].appName,
                    'type':add[key].type,
                    'classifyName':add[key].classifyName,
                    'versionNum':add[key].versionNum,
                    
                })

        }
          this.multipleSelection = this.multipleSelection.filter(item => item.classifyId); //去重，防止同一条数据出现两次
           }
            }else{
                  this.multipleSelection = val;
            } 
           this.$emit('sendStatus', this.multipleSelection,false)
         },
            //  父组件选择事件
            emitchose(data){
              this.$emit('sendStatus', data)
            },
                    // 获取列表
        gethisInfo(){
            if( this.authType == '1'){
              this.radio1 = this.authType 
            }
            if(typeof(this.value) == "undefined") this.value = ""
            let params = {
                appName:this.search,
                id:this.search1,
                classifyId:this.value,
                state:this.radio1,
                type:this.radio,
                payType:this.radio2,
                current: this.currentPage,
                size:this.PageSize,
                officialType:this.radio3
            }
            getApplicationList(params)
            .then(res => {
                let that = this
             if(this.bussID && !this.importName){
              // let haveLen = res.data.records.filter(item=> item.id == that.bussID || item.id ==0 || item.state == 0)
               this.list = res.data.records.filter(item=> item.id != that.bussID && item.id !=0 && item.state != 0) 
               this.totalCount = res.data.total;
             }else{
              this.list = res.data.records
             this.totalCount = res.data.total;
             }
             if(this.selectType){
                      let rows = []
                      if(!this.isAppId){
                        console.log(1)
                         for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].id === this.list[n].id || this.selsctarr[m].relatedAppId === this.list[n].id || this.selsctarr[m].appId === this.list[n].id) {
                            
                            rows.push(this.list[n])
                        }
                        }
                    }
                      }else{
                            for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].relatedAppId == this.list[n].id || this.selsctarr[m].id === this.list[n].id) {
                            console.log(this.selsctarr[m].appId)
                            rows.push(this.list[n])
                        }
                        }
                    }
                      }
                       rows.forEach(row => {
                        that.$refs.multipleTable.toggleRowSelection(row,true)
                    })
 
             }
            })
            .catch(err => {
            })
        },
                // 新增修改调用方法
        editfun(val){
            this.selsctarr = val        
        },
        // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
           // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
        // 搜索
        searchList(){
              this.currentPage = 1
              this.gethisInfo()
        },
          // 重置
        reset(){
            this.search = ""
            this.search1 = ""
            this.value = "",
            this.radio = "",
            this.radio1 = "",
            this.radio2 = "",
            this.radio3 = "",
            this.currentPage = 1
            this.gethisInfo()
        },
        // 获取企业分类
        getthisType(){
            this.itemList = []
             getApplicationTypeList({
                name:'',
                officialType:'',
             })
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                  this.itemList.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 新增应用
        addApp(){
            this.$router.push("/editApplication")
        },
        // 企业分类筛选
        classSelect(value){
            this.currentPage = 1
            if(value){
                let index = value.length-1
                this.value = value[index]
                 this.gethisInfo()
                //  this.$refs.cascaderRef.dropDownVisible = false
            }else{
              this.value = ""
            }
           
        },
        // 应用类型
        allradio(type){
            if(type == 0) this.radio = ""
            if(type == 1 ) this.radio1 = ""
            if(type == 2 ) this.radio2 = ""
            if(type == 3 ) this.radio3 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
         handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
    // 应用状态改变
    changeStatus(e){
     if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '应用禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editApp(e)
                        }).catch(() => {          
                        });
        }else{
            this.editApp(e)
        }
      },
        editApp(e){
             editApplication({
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('应用状态修改成功'); 
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
    }
}
</script>
<style lang="scss" scoped>
#Application{
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
  .businessList-container {
       .businessList-container-table {
      margin-top: 20px;
       .buStatus{
        width: 50px;
        margin: 0 auto;
      }
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep{
     .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
        .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
                .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
           .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
}
</style>